import { forEach } from 'lodash';
import {
  SAVE_RESERVATIONS,
  REMOVE_RESERVATION
} from '../actions/constantsActions';

const reservationsReducer = (state = {}, action) => {
  const newState = {};
  const newData = {};
  switch (action.type) {
    case SAVE_RESERVATIONS:
      forEach(action.data, (reservation) => {
        newState[reservation.reservationId] = reservation;
      });

      return {
        ...state,
        ...newState
      };

    case 'REPLACE_RESERVATIONS':
      forEach(action.data, (reservation) => {
        newData[reservation.reservationId] = reservation;
      });
      return {
        ...newData
      };

    case REMOVE_RESERVATION: {
      const newState = Object.values(state).filter((reservation) => {
        return reservation.reservationId !== action.reservationId;
      });
      newState.reduce((obj, item) => {
        const newObject = obj;
        newObject[item.id] = item;
        return newObject;
      }, {});
      return {
        ...newState
      };
    }
    default:
      return state;
  }
};

export default reservationsReducer;
